import React from "react";

import { useMediaQuery } from "@mui/material";

type MenuOpenType = {
    isMenuOpen: boolean;
};

function getDefaultMenuOpen(): MenuOpenType {
    return { isMenuOpen: true };
}

export const MenuOpenContext = React.createContext<MenuOpenType>(getDefaultMenuOpen());

export const MenuOpenActionsContext = React.createContext({
    toogleMenuOpen: () => {
        // empty function
    },
    setIsMenuOpen: (_open: boolean) => {
        // empty function
    },
    toggleMenuWhenClose: () => {
        // empty function
    },
});

export const useMenuOpenContext = () => React.useContext(MenuOpenContext);

export const useMenuOpenActionsContext = () => React.useContext(MenuOpenActionsContext);

type PropsType = {
    children: any;
    maxWidthMenuPx?: string;
};

export const MenuOpenContextProvider = ({ children, maxWidthMenuPx = "1200px" }: PropsType) => {
    const [isMenuOpen, setIsMenuOpen] = React.useState<boolean>(true);

    const matches = useMediaQuery(`(max-width: ${maxWidthMenuPx})`);

    const toogleMenuOpen = React.useCallback(() => {
        setIsMenuOpen((prevState) => !prevState);
    }, []);

    const toggleMenuWhenClose = React.useCallback(() => {
        if (matches) {
            setIsMenuOpen(false);
        }
    }, [matches]);

    React.useEffect(() => {
        toggleMenuWhenClose();
    }, [toggleMenuWhenClose]);

    const menuOpenContextValue = React.useMemo(() => ({ isMenuOpen }), [isMenuOpen]);

    const menuOpenActionsContextValue = React.useMemo(
        () => ({ toogleMenuOpen, setIsMenuOpen, toggleMenuWhenClose }),
        [toogleMenuOpen, setIsMenuOpen, toggleMenuWhenClose]
    );

    return (
        <MenuOpenContext.Provider value={menuOpenContextValue}>
            <MenuOpenActionsContext.Provider value={menuOpenActionsContextValue}>
                {children}
            </MenuOpenActionsContext.Provider>
        </MenuOpenContext.Provider>
    );
};
